  <template >
   <div class="formPosition" v-role="'func'">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col >
         <span>Cadastrar nova Turma - Escolhe a classe </span>

                 <v-icon large color="green darken-2">forward</v-icon>

<div class="text-center">

    <v-btn @click="classe(1)" class="ma-2" outlined color="indigo"><v-icon  small color="primary" >filter_1</v-icon> 10ª classe</v-btn>
    <v-btn @click="classe(2)" class="ma-2" outlined color="indigo"><v-icon  small  color="primary" >filter_2</v-icon> 11ª classe</v-btn>
    <v-btn @click="classe(3)" class="ma-2" outlined color="indigo"><v-icon  small  color="primary" >filter_3</v-icon> 12ª classe</v-btn>
    <v-btn @click="classe(4)"
     class="ma-2" outlined color="indigo"><v-icon  small  color="primary" >filter_4</v-icon> 13ª classe</v-btn>
  </div>
      </v-col>

    </v-row>
  </v-container>
  </template>
   </div>
  </template>

<script>
export default {
  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  methods: {
    classe (idclasse) {
      const ls = require('local-storage')
      this.$store.state.isloading = true
      this.$store.state.idclasse = idclasse
      if (idclasse === 1) {
        this.$store.state.classeTur = '10ªC-' + ls.get('anolectivo')
      } else if (idclasse === 2) {
        this.$store.state.classeTur = '11ªC-' + ls.get('anolectivo')
      } else if (idclasse === 3) {
        this.$store.state.classeTur = '12ªC-' + ls.get('anolectivo')
      } else if (idclasse === 4) {
        this.$store.state.classeTur = '13ªC-' + ls.get('anolectivo')
      }
      this.$router.push('turmacrud')

      //  this.$store.dispatch('setidclasse', idclasse)
    }
  }
}
</script>
